import { ICON_CHEVRON_DIRECTION } from './IconChevron.constants'

export function getVerticalIconChevronDirection(isOpen) {
  return isOpen ? ICON_CHEVRON_DIRECTION.UP : ICON_CHEVRON_DIRECTION.DOWN
}

export function getHorizontalIconChevronDirection(isLeftSide) {
  return isLeftSide ? ICON_CHEVRON_DIRECTION.LEFT : ICON_CHEVRON_DIRECTION.RIGHT
}
